import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSolicitudesClienteAprobadas, clearErrors } from '../../../redux/actions/dataasistencialactions';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import './SolicitudesClienteAprobadas.css';
import { FaArrowCircleLeft } from 'react-icons/fa';

class SolicitudesClienteAprobadas extends Component {
  componentDidMount() {
    this.props.getSolicitudesClienteAprobadas(this.props.match.params.clienteId);
  }

  render() {
    const { solicitudes, loadingdataasistencial } = this.props.dataAsistencial;
    const clienteId = this.props.match.params.clienteId;

    const columns = [
  {
    field: 'acciones',
    headerName: 'Acciones',
    width: 120,
    sortable: false,
    renderCell: (params) => (
      <Tooltip title="Ver Solicitud">
        <IconButton
          component={Link}
          to={`/dashboard/perfilcliente/${clienteId}/solicitud/${params.row.solicitudid}`}
          size="small"
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'titulo', headerName: 'Título', flex: 1 },
  { field: 'area', headerName: 'Área', flex: 1 },
  { field: 'servicio', headerName: 'Servicio', flex: 1 }
];
    const rows = solicitudes ? solicitudes.map((row, index) => ({ id: index, ...row })) : [];

    return (
      <Box>
        <Box className="titulo_section">
          <Box className="titulo_clientes">
            <h1 className="text-clientes">Mis Solicitudes de Compras Aprobadas</h1>
            <hr className="clientes_separator" />
          </Box>
          <Box className="div_boton">
            <Link to={`/dashboard/perfilcliente/${clienteId}`}>
              <Tooltip title="Volver">
                <IconButton>
                  <FaArrowCircleLeft color="#03178C" />
                </IconButton>
              </Tooltip>
            </Link>
          </Box>
        </Box>

        <Box className="table_container" sx={{ height: 500, width: '100%', mt: 2, '& .MuiDataGrid-columnHeaders': { backgroundColor: 'primary.main', color: 'white' } }}>
          {!loadingdataasistencial ? (
            <DataGrid
              rows={rows}
              columns={columns}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              components={{ Toolbar: () => (
                <Box p={1}>
                  <GridToolbarQuickFilter placeholder="Buscar solicitud..." />
                </Box>
              ) }}
            />
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
              <CircularProgress size={50} color="primary" />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

SolicitudesClienteAprobadas.propTypes = {
  getSolicitudesClienteAprobadas: PropTypes.func.isRequired,
  dataAsistencial: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  dataAsistencial: state.dataAsistencial,
  UI: state.UI
});

export default connect(mapStateToProps, { getSolicitudesClienteAprobadas, clearErrors })(SolicitudesClienteAprobadas);
